import { createFileRoute } from '@tanstack/react-router';

import { Discover } from '#modules/finder/features/posts/components/Discover';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/discover/_discover/'
)({
  component: Discover,
  ssr: false,
});
